<template>
  <div>
    <div class="search-functions">
      <BBtnPrimary
        style="margin-right: 5px; margin-left: 5px"
        :clicked="doUpdate"
        hidden-key=""
        btn-txt="编辑"
      />
      <BBtnPrimary
        style="margin-right: 5px; margin-left: 5px"
        :clicked="doBack"
        hidden-key=""
        btn-txt="返回"
      />
    </div>
    <div class="main3">
      <img
        :src="
          accountInfo.idPhotoUrl
            ? accountInfo.idPhotoUrl
            : require('@/assets/head_photo.png')
        "
        width="260px"
        height="260px"
      />
    </div>
    <div class="main2">
      <div class="mainO">
        <label>姓名:</label>
        <label class="lable2">{{ accountInfo.userName }}</label>
      </div>
      <div class="main">
        <label>性别:</label>
        <label class="lable2">{{ accountInfo.sex == '01' ? '男' : '女' }}</label>
      </div>
      <div class="main">
        <label>年龄:</label>
        <label class="lable2">{{ accountInfo.age }}</label>
      </div>
      <div class="main">
        <label>身份证号:</label>
        <label class="lable2">{{ accountInfo.idCardNum }}</label>
      </div>
      <div class="main">
        <label>手机号码:</label>
        <label class="lable2">{{ accountInfo.telNo }}</label>
      </div>
      <div class="main">
        <label>添加时间:</label>
        <label class="lable2">{{ accountInfo.createTime }}</label>
      </div>
    </div>
    <div class="record">
      <div id="course-management-public" fluid tag="section">
        <div>
          <div class="left-pad">
            <div>
              <AppBar @changed="tabchange" />
            </div>
          </div>
          <div class="component-left-pad">
            <div v-show="showFlg">
              <div>
                <div class="main2">
                  <BInputPullDown
                    label-name="课程："
                    v-model="curriculum"
                    :Options="curriList"
                    @changed="doClick"
                    placeholder="全部"
                  />
                </div>
                <div style="margin-top: -13px;">
                  <label class="lablea">
                    <span style="margin-right: 4%;">
                      签到次数：{{ signinNum }}</span>
                      学习进度：
                    <span style="color:#c7c702">
                      {{ learnRate }}</span>
                  </label>
                </div>
                <div class="tables">
                  <Table
                    :headers="headers"
                    :tableData="signinList"
                    :total-visible="7"
                    :page-num="page"
                  ></Table>
                </div>
              </div>
            </div>
            <div v-show="cshowFlg">
              <div class="tables">
                <Table
                  :headers="currheaders"
                  :tableData="curriculumList"
                  :total-visible="7"
                  :page-num="page"
                ></Table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import AppBar from "../../components2/AppBar-student-detail";
import { detail, signInSearch, editDetail } from "@/api/student";
import BBtnPrimary from "../../components2/BBtnPrimary";
import BInputPullDown from "../../components2/BInputPullDown";
import Table from "../../components2/Table";
export default {
  name: "CourseManagement",
  components: {
    AppBar,
    BBtnPrimary,
    BInputPullDown,
    Table,
  },
  data() {
    return {
      accountInfo: {
        id: 0,
        userName: "",
        age: "",
        sex: "",
        idCardNum: "",
        telNo: "",
        idPhotoUrl: "",
        studentId: "",
      },
      headers: [
        { text: "ID", value: "indexNum", sortable: false, align: "center" },
        { text: "日期", value: "signInDate", sortable: false, align: "center" },
        { text: "时间", value: "signInTime", sortable: false, align: "center" }, 
      ],
      currheaders: [
        { text: "ID", value: "indexNum", sortable: false, align: "center" },
        { text: "课程", value: "courseName", sortable: false, },
        { text: "专业", value: "majorName", sortable: false, },
        {
          text: "学习进度",
          value: "studentProgress",
          sortable: false,
          align: "center",
        },
        {
          text: "学习时长",
          value: "studentDuration",
          sortable: false,
          align: "center",
        },
      ],
      loading: false,
      showFlg: true,
      cshowFlg: false,
      userid: 0,
      pageNum: 1,
      page: 0,
      limit: 10,
      totalPageC: 0,
      totalCountC: 0,
      totalPageS: 0,
      totalCountS: 0,
      createTime: "",
      signinNum: 0,
      learnRate: 0,
      curriculum: '',
      signinList: [],
      curriculumList: [],
      curriList: [],
    };
  },
  created() {
    if (sessionStorage.getItem("store")) {
      this.$store.replaceState(
        Object.assign(
          {},
          this.$store.state,
          JSON.parse(sessionStorage.getItem("store"))
        )
      );
      sessionStorage.removeItem("store");
    }
    window.addEventListener("beforeunload", () => {
      sessionStorage.setItem("store", JSON.stringify(this.$store.state));
    });
  },
  // 页面载入之前
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      const params = {
        userid: vm.$route.params.id,
        classId: vm.$route.params.classId,
        studentId: vm.$route.params.studentId,
      };

      if (
        params.userid !== null &&
        params.userid !== "" &&
        params.userid !== undefined
      ) {
        // 把不为空的参数存入缓存
        vm.$store.commit("SET_STUDENT_ADD_PARAMS", params);
      }
        // 查询条件赋值
        if (vm.$store.state.studentAdd_userid !== undefined && vm.$store.state.studentAdd_userid !==
          null && vm.$store.state.studentAdd_userid !== '') {
          vm.userid = vm.$store.state.studentAdd_userid;
          vm.accountInfo.classId = vm.$store.state.studentAdd_classId;
          vm.accountInfo.studentId = vm.$store.state.studentAdd_studentId;
        } 
      // 页面初期化
      vm.init();
    });
  },
  methods: {
    // 初始化
    async init() {
      var param = {
        id: this.userid,
        classId: this.accountInfo.classId,
        studentId: this.accountInfo.studentId,
      };
      const data = await detail(param);
      this.signinList = data.data.signInVO.signInItemVOList;
      this.signinNum = data.data.signInVO.signInNum;
      this.learnRate = data.data.signInVO.learnRate;
      this.curriculumList = data.data.courseItemList;
      this.curriList = data.data.courseList;
      this.curriculum = ''
      this.searchDetail();
    },
    async searchDetail() {
      var param = {
        studentId: this.accountInfo.studentId,
        classId: this.accountInfo.classId,
      };
      const data = await editDetail(param);
      this.accountInfo.userName = data.data.userName;
      this.accountInfo.idCardNum = data.data.idCardNum;
      this.accountInfo.telNo = data.data.telNo;
      this.accountInfo.age = data.data.age;
      this.accountInfo.userName = data.data.userName;
      this.accountInfo.idPhotoUrl = data.data.idPhotoUrl;
      this.accountInfo.sex = data.data.sex;
      this.accountInfo.createTime = data.data.createTime;
    },
    // 编辑
    doUpdate() {
      this.$router.push({
        name: "student-add",
        params: {
          // 学生id
          id: this.accountInfo.studentId,
          classId: this.accountInfo.classId,
          isHas: 1,
        },
      });
    },
    // 返回
    doBack() {
      this.$store.commit("REMOVE_STUDENT_ADD_PARAMS");
      this.updateSuccess = false;
      this.$router.push({
        name: "student-management",
        params: {},
      });
    },
    // 选择记录
    tabchange(flag) {
      this.showFlg = false;
      this.cshowFlg = false;
      if (flag == 1) {
        this.showFlg = true;
      } else if (flag == 2) {
        this.cshowFlg = true;
      }
    },
    // 点击课程
    async doClick(val) {
      var param = {
        courseId: val,
        studentId: this.accountInfo.studentId,
      };
      const data = await signInSearch(param);
      this.signinList = data.data.signInItemVOList;
      this.signinNum = data.data.signInNum;
    },
  },
};
</script>

<style lang="scss" scoped>
.main {
  position: relative;
  padding-top: 28px;
  display: flex;
  flex-wrap: wrap;
  margin-left: 20px;
}
.record {
  margin-top: 20px;
}
.mainO {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  margin-left: 20px;
}
.main2 {
  display: inline-block;
  margin-top: 10px;
  margin-left: -10px;
}
.main3 {
  display: inline-block;
  margin-left: 30px;
  margin-top: -100px;
}
.search-functions {
  position: relative;
  top: 0;
  display: flex;
  margin-left: 90%;
  margin-top: 10px;
}
.lablea {
  margin-left: 70%;
}
.lable2 {
  margin-left: 10px;
}
.title {
  margin-left: 20px;
}
.tables {
  width: 93%;
  margin-left: 30px;
  margin-right: 30px;
}
.btn-detail {
  margin: 0 20px 0 20px;
  color: #0171a3;
  cursor: pointer;
}
.left-pad {
  padding-left: 20px;
}
.component-left-pad {
  padding-left: 30px;
}
</style>
